const logo = require('../images/logo.jpg');

export default logo;
